import React, { useEffect, useState, useRef } from "react";
import { Button, Modal, Spin, Tooltip, InputNumber, Drawer } from "antd";
import handleLocationClick from "../../../../utils/handleLocationClick";
import { useDispatch, useSelector } from "react-redux";
import { GoogleMap, Marker, InfoWindow } from "@react-google-maps/api";
import { useJsApiLoader } from "@react-google-maps/api";
import CardContainer from "../CardContainer";
import { Image } from "antd";
import dateAvailability, {
  blockedRangeDisplayLabel,
  getMergedBlockedDateDocuments,
  getMergedCalendarBookings,
  getMergedFocBookings,
  getMergedPremiumBlockEntries,
  getMergedRotationalBookings,
} from "../../../../utils/dateAvailability";
import { CiLocationArrow1 } from "react-icons/ci";
import "./DashboardContainer.css";
import {
  getInventories,
  setSideTab,
} from "../../../toolkit/slices/inventories/inventorySlice";
import { Switch, Calendar } from "antd";
import NamedSelectComponent from "../../components/NamedSelectComponent";
import { addToCartInBulk } from "../../../toolkit/slices/cart/cartSlice";
import MapView from "./MapView";
import moment from "moment";
import RectangleGenerator from "../../components/ReactangleGenerator";
import CalendarFilterComponent from "../../components/CalendarFilterComponent";
import { IoIosRefresh } from "react-icons/io";
import sortAlphabetically from "../../../../utils/sortAlphabetically";
import { FaInbox } from "react-icons/fa";
import rpmCalcUnits from "../../../../utils/rpmCalcUnits";
import formatIndianNumber from "../../../../utils/formatIndianNumber";
import multiFilter from "../../../../utils/multiFilter";
import { useMediaQuery } from "@material-ui/core";
import { IoFilterSharp } from "react-icons/io5";
import accessCheckPromise from "../../../../utils/accessCheck";
import AuthorizationError from "../AuthorizationError";
import { logoutUser } from "../../../toolkit/slices/users/userSlice";
const center = { lat: 23.0225, lng: 72.5714 };
// const optionsForTypes = [
//   { label: "Hoarding", value: "Hoarding" },
//   { label: "Unipole", value: "Unipole" },
//   { label: "Gantry", value: "Gantry" },
//   { label: "Cantilever", value: "Cantilever" },
//   { label: "LED", value: "LED" },
//   { label: "Kiosk", value: "Kiosk"},
// ];
const data = [
  { startDate: "2024-04-04", endDate: "2024-04-08" },
  { startDate: "2024-05-01", endDate: "2024-05-04" },
  { startDate: "2024-05-08", endDate: "2024-05-10" },
];
const optionsForStatus = [
  { label: "UP", value: "UP" },
  { label: "Immediate", value: "Immediate" },
];
// const optionsforArea = [
//   { label: "AEC", value: "AEC" },
//   { label: "Airport Road", value: "Airport Road" },
//   { label: "Ambavadi", value: "Ambavadi" },
//   { label: "Ashram Road", value: "Ashram Road" },
// ];
const optionsForPriceRange = [
  // { label: "All", value: "all" },
  { label: "50,000-70,000", value: "50,000-70,000" },
  { label: "70,000-80,000", value: "70,000-80,000" },
  { label: "90,000-100,000", value: "90,000-100,000" },
];
const gcpApiKey = process.env.REACT_APP_GCP_API_KEY;
const libraries = ["places"];
const colors = ["#FFD905", "#FF0000"];
function DashboardContainer() {
  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: gcpApiKey,
    libraries: libraries,
  });
  let dashboardCards = useRef();
  const [strDate, setStrDate] = useState(null);
  const [duration, setDuration] = useState(15);
  // const dateCellRender = (date) => {
  //   const dateString = date.format('YYYY-MM-DD');
  //   let flag1 = false;
  //   let count = 0;
  //   let colorD;
  //   // Check which booking the date falls into and get the associated color
  //   const booking = selectedData.Bookings.find(({ startDate, endDate }) => {
  //     const start = moment(startDate).format('YYYY-MM-DD');
  //     const end = moment(endDate).format('YYYY-MM-DD');
  //     const today = moment().format('YYYY-MM-DD');
  //     if (today >= start && today <= end) {
  //       colorD = colors[0]
  //       flag1 = true;
  //     } else {
  //       if (start > today) {
  //         if (strDate == null && !flag1) {
  //           setStrDate(start);
  //           colorD = colors[0]
  //         } else {
  //           if (strDate == start && !flag1) {
  //             colorD = colors[0]
  //           } else {
  //             colorD = colors[1]
  //           }
  //         }

  //       } else {
  //         colorD = colors[1];
  //       }

  //     }
  //     return dateString >= start && dateString <= end;
  //   });
  //   const color = booking ? colorD : '';
  //   const tooltipContent = booking?.bdfId ? `Booked by ${booking?.bdfId?.brandId?.brandName}` : booking?.displayName ? `Booked By ${booking?.displayName}` : "Brand Name Not Available";

  //   return (
  //     <Tooltip title={tooltipContent} placement="top">
  //       <div className={booking ? "range-cell" : ""} style={{ backgroundColor: color }}>
  //         {booking && <span className="dot"></span>}
  //       </div>
  //     </Tooltip>
  //   );
  // };

  const dateCellRender = (date) => {
    const dateString = date.format("YYYY-MM-DD");
    let colorD;

    const calendarBookings = getMergedCalendarBookings(
      selectedData,
      selectedData?.Bookings,
    );

    // Check for regular bookings (self + linked half/full, same as dateAvailability).
    // Skip premiumBlock rows: they share the merged list but use premiumId; tooltip/dots use premiumBlocking.
    const booking = calendarBookings.find(
      ({ startDate, endDate, premiumId }) => {
        if (premiumId) return false;
        const start = moment(startDate).format("YYYY-MM-DD");
        const end = moment(endDate).format("YYYY-MM-DD");
        const today = moment().format("YYYY-MM-DD");

        if (today >= start && today <= end) {
          colorD = colors[0]; // Primary color for bookings within range
        } else if (start > today) {
          if (!strDate) {
            setStrDate(start);
            colorD = colors[0];
          } else if (strDate === start) {
            colorD = colors[0];
          } else {
            colorD = colors[1]; // Secondary color for future bookings
          }
        } else {
          colorD = colors[1];
        }
        return dateString >= start && dateString <= end;
      },
    );

    // FOC / rotational: self + linked half/full (same as dateAvailability)
    const focBooking = getMergedFocBookings(selectedData).find(
      ({ startDate, endDate }) => {
        const start = moment(startDate).format("YYYY-MM-DD");
        const end = moment(endDate).format("YYYY-MM-DD");
        return dateString >= start && dateString <= end;
      },
    );
    const rotationalBooking = getMergedRotationalBookings(selectedData).find(
      ({ startDate, endDate }) => {
        const start = moment(startDate).format("YYYY-MM-DD");
        const end = moment(endDate).format("YYYY-MM-DD");
        return dateString >= start && dateString <= end;
      },
    );

    // Blocked ranges from self + linked half/full
    const blockedDate = getMergedBlockedDateDocuments(selectedData).find(
      (block) => {
        const start = moment(block.blockedAt).format("YYYY-MM-DD");
        const end = moment(block.blockedTill).format("YYYY-MM-DD");
        return dateString >= start && dateString <= end;
      },
    );

    const premiumBlocking = getMergedPremiumBlockEntries(selectedData).find(
      ({ startDate, endDate }) => {
        const start = moment(startDate).format("YYYY-MM-DD");
        const end = moment(endDate).format("YYYY-MM-DD");
        return dateString >= start && dateString <= end;
      }
    );

    const tooltipContent = [];

    // Prepare tooltip content for booking
    if (booking) {
      tooltipContent.push(
        booking.bdfId?.campaignName
          ? `Booking - ${booking.bdfId?.campaignName}`
          : booking.bdfId
            ? `Booked by ${booking.bdfId.brandId?.brandName || booking.bdfId.brandId?.partyName}`
            : booking.displayName
              ? `Booked by ${booking.displayName}`
              : "Booking - Brand Name Not Available"
      );
    }

    // Prepare tooltip content for FOC booking
    if (focBooking) {
      tooltipContent.push(
        focBooking.bdfId?.campaignName
          ? `FOC Booking - ${focBooking.bdfId?.campaignName}`
          : `FOC Booking by ${focBooking.bdfId?.brandId?.brandName ||
          focBooking.bdfId?.brandId?.partyName ||
          focBooking.displayName ||
          "FOC - Brand Name Not Available"
          }`
      );
    }
    // Prepare tooltip content for Rotational booking
    if (rotationalBooking) {
      tooltipContent.push(
        rotationalBooking.bdfId?.campaignName
          ? `R Booking - ${rotationalBooking.bdfId?.campaignName}`
          : `R Booking by ${rotationalBooking.bdfId?.brandId?.brandName ||
          rotationalBooking.bdfId?.brandId?.partyName ||
          rotationalBooking.displayName ||
          "R - Brand Name Not Available"
          }`
      );
    }

    // Prepare tooltip content for blocked dates
    if (blockedDate) {
      tooltipContent.push(blockedRangeDisplayLabel(blockedDate));
    }

    if (premiumBlocking) {
      tooltipContent.push(
        premiumBlocking?.premiumId?.campaignName
          ? `Premium Blocking - ${premiumBlocking?.premiumId?.campaignName}`
          : `Premium Blocking by ${premiumBlocking?.premiumId?.parentCompanyId?.name}`
      );
    }

    // Combine tooltips
    const combinedTooltip = tooltipContent.join(" | ");

    return (
      <Tooltip
        title={combinedTooltip}
        placement="top"
        mouseEnterDelay={0}
        open={hoveredDateString === dateString}
      >
        <div
          className={
            booking ||
              focBooking ||
              blockedDate ||
              rotationalBooking ||
              premiumBlocking
              ? "range-cell"
              : ""
          }
          style={{ position: "relative", minHeight: "20px" }}
          onMouseEnter={() => setHoveredDateString(dateString)}
          onMouseLeave={() => setHoveredDateString(null)}
        >
          {booking && (
            <span
              className="dot"
              style={{
                backgroundColor: colorD,
                width: "7px",
                height: "7px",
                borderRadius: "50%",
              }}
            ></span>
          )}
          {focBooking && (
            <span
              className="dot"
              style={{
                backgroundColor: "#05b91f",
                width: "7px",
                height: "7px",
                borderRadius: "50%",
              }}
            ></span>
          )}
          {rotationalBooking && (
            <span
              className="dot"
              style={{
                backgroundColor: "black",
                width: "7px",
                height: "7px",
                borderRadius: "50%",
              }}
            ></span>
          )}
          {blockedDate && (
            <span
              className="dot"
              style={{
                backgroundColor: "#646363",
                width: "7px",
                height: "7px",
                borderRadius: "50%",
              }}
            ></span>
          )}
          {premiumBlocking && (
            <span
              className="dot"
              style={{
                backgroundColor: "#62c4f5",
                width: "7px",
                height: "7px",
                borderRadius: "50%",
              }}
            ></span>
          )}
        </div>
      </Tooltip>
    );
  };

  // const dateCellRender = (date) => {
  //   const dateString = date.format('YYYY-MM-DD');

  //   // Check which booking the date falls into and get the associated color
  //   const booking = selectedData.Bookings.find(({ startDate, endDate }) => {
  //     const start = moment(startDate).format('YYYY-MM-DD');
  //     const end = moment(endDate).format('YYYY-MM-DD');
  //     return dateString >= start && dateString <= end;
  //   });

  //   const color = booking ? colors[Math.floor(selectedData.Bookings.indexOf(booking) % colors.length)] : '';

  //   return (
  //     <div className={booking ? "range-cell" : ""} style={{ backgroundColor: color }}>
  //       {booking && <span className="dot"></span>}
  //     </div>
  //   );
  // };
  let inventoriesV = useSelector((state) => state.inventoriesList.inventories);
  const [inventories, setInventories] = useState(inventoriesV);
  const [filteredInventories, setFilteredInventories] = useState([]);
  const [specialInv, setSpecialInv] = useState(inventoriesV); // this is made specially for search Query
  const [access, setAccess] = useState(null);
  const [lightInv, setLightInv] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedData, setSelectedData] = useState(null);
  const [selectedItemsOnType, setSelectedItemsOnType] = useState([]);
  const [selectedItemsOnArea, setSelectedItemsOnArea] = useState([]);
  const [selectedItemsOnZone, setSelectedItemsOnZone] = useState([]);
  const [selectStartDate, setSelectStartDate] = useState(null);
  const [selectEndDate, setSelectEndDate] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [optionsForTypes, setOptionsForTypes] = useState([]);
  const [optionsForArea, setOptionsForArea] = useState([]);
  const [display, setDisplay] = useState(null);
  const [nextBooking, setNextBooking] = useState(null);
  const [hoveredDateString, setHoveredDateString] = useState(null);

  const [filteredAreas, setFilteredAreas] = useState([]);
  const [filteredZones, setFilteredZones] = useState([]);
  const [filteredMediaTypes, setFilteredMediaTypes] = useState([]);
  const [mediaTypes, setMediaTypes] = useState([]);
  const [areas, setAreas] = useState([]);
  const [zones, setZones] = useState([]);
  const [typeCounts, setTypeCounts] = useState({});
  const [areaCounts, setAreaCounts] = useState({});
  const [zoneCounts, setZoneCounts] = useState({});
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width:769px)");

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };
  // console.log("Fista", moment(selectStartDate).format("YYYY-MM-DD"), moment(selectEndDate).format("YYYY-MM-DD"))
  const dispatch = useDispatch();
  const showModal = (item) => {
    setSelectedData(item);
    setDisplay(dateAvailability(item?.Bookings, true, item)?.display);
    setNextBooking(dateAvailability(item?.Bookings, true, item)?.nextBooking);
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
    setHoveredDateString(null);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setHoveredDateString(null);
  };
  const client = useSelector((state) => state.client);
  const user = useSelector((state) => state.user);
  const searchQuery = useSelector((state) => state.inventoriesList.searchQuery);

  useEffect(() => {
    dispatch(setSideTab(window.location.pathname));
    dispatch(getInventories());
    accessCheckPromise()
      .then((res) => setAccess(res))
      .catch((error) => {
        dispatch(logoutUser());
      });
  }, []);
  useEffect(() => {
    if (filteredInventories?.length > 0 && loading) {
      setLoading(false);
    }
  }, [filteredInventories]);

  useEffect(() => {
    setInventories(inventoriesV);
    const typeNames = Array.from(
      new Set(inventoriesV.map((item) => item.typeOfMedia?.name?.trim()))
    );
    const areaNames = Array.from(
      new Set(inventoriesV.map((item) => item.locations?.Area?.trim()))
    );
    const zoneNames = Array.from(
      new Set(
        inventoriesV.map((item) => item.locations?.zone?.trim()).filter(Boolean)
      )
    );
    setMediaTypes(typeNames);
    setAreas(areaNames);
    setZones(zoneNames);
    setFilteredInventories([...inventoriesV]);
    if (inventoriesV.length > 0) {
      setSpecialInv((prev) => {
        return [...inventories];
      });
    }
  }, [inventoriesV, inventories]);

  //setting filter options
  // useEffect(() => {
  //   let dataForTypes = [];
  //   let dataForArea = [];

  //   if (lightInv.length > 0) {
  //     // Accumulate counts of typeOfMedia.name and locations.Area
  //     const typeCounts = lightInv.reduce((acc, ele) => {
  //       const typeName = ele.typeOfMedia.name;
  //       acc[typeName] = (acc[typeName] || 0) + 1;
  //       return acc;
  //     }, {});

  //     const areaCounts = lightInv.reduce((acc, ele) => {
  //       const areaName = ele.locations.Area;
  //       acc[areaName] = (acc[areaName] || 0) + 1;
  //       return acc;
  //     }, {});

  //     lightInv.forEach(ele => {
  //       dataForTypes.push(ele.typeOfMedia.name);
  //       dataForArea.push(ele.locations.Area);
  //     });

  //     dataForTypes = Array.from(new Set(dataForTypes));
  //     dataForArea = Array.from(new Set(dataForArea));

  //     let modDataTypes = dataForTypes.map(ele => ({
  //       label: `${ele}(${typeCounts[ele]})`,
  //       value: ele
  //     }));

  //     let modDataArea = dataForArea.map(ele => ({
  //       label: `${ele}        (${areaCounts[ele]})`,
  //       value: ele
  //     }));

  //     setOptionsForTypes(sortAlphabetically(modDataTypes));
  //     setOptionsForArea(sortAlphabetically(modDataArea));
  //   }
  // }, [inventories]);

  // useEffect(() => {
  //   const trimmedQuery = searchQuery.trim().toLowerCase();

  //   if (trimmedQuery !== "") {
  //     let filtered;

  //     const filterFunction = (inventory) => {
  //       return (
  //         inventory?.locations?.name?.trim().toLowerCase().includes(trimmedQuery) ||
  //         inventory?.CodeNo?.trim().toLowerCase().includes(trimmedQuery) ||
  //         inventory?.CASCode?.trim().toLowerCase().includes(trimmedQuery) ||
  //         inventory?.typeOfMedia?.name?.trim().toLowerCase().includes(trimmedQuery)
  //       );
  //     };

  //     if (specialInv.length) {
  //       filtered = specialInv.filter(filterFunction);
  //     } else {
  //       filtered = inventoriesV.filter(filterFunction);
  //     }

  //     setFilteredInventories(filtered);
  //   } else {
  //     if (specialInv.length > 0) {
  //       setFilteredInventories(specialInv);
  //     } else {
  //       setFilteredInventories(inventoriesV);
  //     }
  //   }
  // }, [searchQuery, inventories]);

  //options cascading effect
  // useEffect(() => {
  //   if (selectedItemsOnType.length > 0) {
  //     // Data is filtered based on Types
  //     let data = inventories.filter((ele) => {
  //       if (selectedItemsOnArea.length > 0) {
  //         return selectedItemsOnType.some(type => new RegExp(type, 'i').test(ele.typeOfMedia.name)) && selectedItemsOnArea.some(area => new RegExp(area, 'i').test(ele.locations.Area));
  //       } else {
  //         return selectedItemsOnType.some(type => new RegExp(type, 'i').test(ele.typeOfMedia.name));
  //       }
  //     });

  //     let dataV = inventories.filter((ele) => {
  //       return selectedItemsOnType.some(type => new RegExp(type, 'i').test(ele.typeOfMedia.name));
  //     });

  //     // Options for Area are cascaded based on filtered dataV
  //     if (dataV.length > 0) {
  //       let modDataArea = [...new Set(dataV.map(q => q.locations.Area.trim()))];
  //       let result = modDataArea.map(ele => ({
  //         label: `${ele}        (${dataV.filter(q => q.locations.Area === ele).length})`,
  //         value: ele,
  //       }));
  //       setOptionsForArea(sortAlphabetically(result));
  //     }

  //     // Set filtered inventories
  //     setFilteredInventories(data);
  //     setSpecialInv([...data]);
  //   }

  //   if (selectedItemsOnArea.length > 0) {
  //     // Data is filtered based on Area
  //     let data = inventories.filter((ele) => {
  //       if (selectedItemsOnType.length > 0) {
  //         return selectedItemsOnArea.some(area => new RegExp(area, 'i').test(ele.locations.Area)) && selectedItemsOnType.some(type => new RegExp(type, 'i').test(ele.typeOfMedia.name));
  //       } else {
  //         return selectedItemsOnArea.some(area => new RegExp(area, 'i').test(ele.locations.Area));
  //       }
  //     });

  //     let dataV = inventories.filter((ele) => {
  //       return selectedItemsOnArea.some(area => new RegExp(area, 'i').test(ele.locations.Area));
  //     });

  //     // Options for Types are cascaded based on filtered dataV
  //     if (dataV.length > 0) {
  //       let modDataType = [...new Set(dataV.map(q => q.typeOfMedia?.name))];
  //       let result = modDataType.map(ele => ({
  //         label: `${ele}        (${dataV.filter(q => q.typeOfMedia?.name === ele).length})`,
  //         value: ele,
  //       }));
  //       setOptionsForTypes(sortAlphabetically(result));
  //     }

  //     // Set filtered inventories
  //     setFilteredInventories(data);
  //     setSpecialInv([...data]);
  //   }

  //   if (selectedItemsOnType.length === 0 && selectedItemsOnArea.length === 0 && !searchQuery) {
  //     setFilteredInventories(inventoriesV);
  //     setSpecialInv([...inventoriesV]);

  //     let dataForTypes = [];
  //     let dataForArea = [];
  //     inventories.forEach(ele => {
  //       dataForTypes.push(ele.typeOfMedia?.name.trim());
  //       dataForArea.push(ele.locations?.Area.trim());
  //     });

  //     // Calculate counts before converting to sets
  //     let typeCounts = {};
  //     let areaCounts = {};

  //     dataForTypes.forEach(type => {
  //       typeCounts[type] = (typeCounts[type] || 0) + 1;
  //     });

  //     dataForArea.forEach(area => {
  //       areaCounts[area] = (areaCounts[area] || 0) + 1;
  //     });

  //     dataForTypes = Array.from(new Set(dataForTypes));
  //     dataForArea = Array.from(new Set(dataForArea));

  //     let modDataTypes = dataForTypes.map(ele => ({
  //       label: `${ele}        (${typeCounts[ele]})`,
  //       value: ele,
  //     }));

  //     let modDataArea = dataForArea.map(ele => ({
  //       label: `${ele}        (${areaCounts[ele]})`,
  //       value: ele,
  //     }));

  //     setOptionsForTypes(sortAlphabetically(modDataTypes));
  //     setOptionsForArea(sortAlphabetically(modDataArea));
  //   }
  // }, [selectedItemsOnType, selectedItemsOnArea, inventoriesV, inventories, lightInv]);

  //FILTER
  useEffect(() => {
    // const filtered = inventories && inventories.filter(item => {
    //   if (selectedItemsOnType.length > 0 && !selectedItemsOnType.some(ele=>new RegExp(ele,'i').test(item.typeOfMedia?.name))) {
    //     return false;
    //   }
    //   if (selectedItemsOnArea.length > 0 && !selectedItemsOnArea.some(ele=>new RegExp(ele,'i').test(item.locations?.Area))) {
    //     return false;
    //   }
    //   return true;
    // });
    // setFilteredInventories(filtered);
    // setSpecialInv(filtered);
    let filtered = multiFilter(
      selectedItemsOnType,
      selectedItemsOnArea,
      selectedItemsOnZone,
      selectStartDate,
      selectEndDate,
      inventories,
      searchQuery,
      duration
    );
    setFilteredInventories(filtered);
    setSpecialInv(filtered);
  }, [
    selectedItemsOnType,
    selectedItemsOnArea,
    selectedItemsOnZone,
    selectStartDate,
    selectEndDate,
    searchQuery,
    duration,
    inventoriesV,
  ]);

  //OPTIONS
  useEffect(() => {
    if (selectedItemsOnType.length > 0) {
      const filtered = inventories
        .filter((item) =>
          selectedItemsOnType.includes(item.typeOfMedia?.name?.trim())
        )
        .map((item) => item.locations?.Area?.trim());
      setFilteredAreas(Array.from(new Set(filtered)));
    } else {
      setFilteredAreas(areas);
    }
  }, [selectedItemsOnType, data, areas]);
  useEffect(() => {
    if (selectedItemsOnArea.length > 0) {
      const filtered = inventories
        .filter((item) =>
          selectedItemsOnArea.includes(item.locations?.Area?.trim())
        )
        .map((item) => item.typeOfMedia?.name?.trim());
      setFilteredMediaTypes(Array.from(new Set(filtered)));
    } else {
      setFilteredMediaTypes(mediaTypes);
    }
  }, [selectedItemsOnArea, inventories, mediaTypes]);

  useEffect(() => {
    if (selectedItemsOnType.length > 0 || selectedItemsOnArea.length > 0) {
      let filtered = inventories;
      if (selectedItemsOnType.length > 0) {
        filtered = filtered.filter((item) =>
          selectedItemsOnType.includes(item.typeOfMedia?.name?.trim())
        );
      }
      if (selectedItemsOnArea.length > 0) {
        filtered = filtered.filter((item) =>
          selectedItemsOnArea.includes(item.locations?.Area?.trim())
        );
      }
      const zones = filtered
        .map((item) => item.locations?.zone?.trim())
        .filter(Boolean);
      setFilteredZones(Array.from(new Set(zones)));
    } else {
      setFilteredZones(zones);
    }
  }, [selectedItemsOnType, selectedItemsOnArea, inventories, zones]);

  //COUNT
  const sortedMediaTypes = mediaTypes.sort((a, b) => a.localeCompare(b));
  const sortedAreas = areas.sort((a, b) => a.localeCompare(b));
  const sortedZones = zones.sort((a, b) => a.localeCompare(b));
  // Log the count of the first option in the filters
  useEffect(() => {
    const counts = {};
    sortedMediaTypes.forEach((type) => {
      const count = filteredInventories.filter(
        (item) => item.typeOfMedia.name === type
      ).length;
      counts[type] = count;
    });
    setTypeCounts(counts);
  }, [sortedMediaTypes, filteredInventories]);

  useEffect(() => {
    const counts = {};
    sortedAreas.forEach((area) => {
      const count = filteredInventories.filter(
        (item) => item.locations?.Area?.trim() === area?.trim()
      ).length;
      counts[area] = count;
    });
    setAreaCounts(counts);
  }, [sortedAreas, filteredInventories]);

  useEffect(() => {
    const counts = {};
    sortedZones.forEach((zone) => {
      const count = filteredInventories.filter(
        (item) => item.locations?.zone?.trim() === zone?.trim()
      ).length;
      counts[zone] = count;
    });
    setZoneCounts(counts);
  }, [sortedZones, filteredInventories]);

  //consoles for debugging
  const [toggleState, setToggleState] = useState(false);
  const handleToggle = (checked) => {
    setToggleState(checked);
  };
  const handleReset = (e) => {
    e.preventDefault();
    setSelectedItemsOnType([]);
    setSelectedItemsOnArea([]);
    setSelectedItemsOnZone([]);
    setSelectStartDate(undefined);
    setSelectEndDate(null);
    setDuration(15);
    setFilteredInventories(inventories); // 🤡
    setSpecialInv([...inventories]);
  };
  const clearEndDate = () => {
    setSelectEndDate(null);
  };

  const filterContent = (
    <div
      style={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        gap: ".4rem",
        marginTop: isMobile ? "1rem" : "0",
      }}
    >
      <div>
        <NamedSelectComponent
          options={filteredMediaTypes.map((type) => ({
            label:
              typeCounts[type] > 0 ? `${type} (${typeCounts[type]})` : type,
            value: type,
            count: typeCounts[type],
          }))}
          title="Type"
          selectedItems={selectedItemsOnType}
          setSelectedItems={setSelectedItemsOnType}
        />
      </div>
      <div>
        <NamedSelectComponent
          options={filteredAreas.map((area) => ({
            label:
              areaCounts[area] > 0 ? `${area} (${areaCounts[area]})` : area,
            value: area,
            count: areaCounts[area],
          }))}
          title="Area"
          selectedItems={selectedItemsOnArea}
          setSelectedItems={setSelectedItemsOnArea}
        />
      </div>
      <div>
        <NamedSelectComponent
          options={filteredZones.map((zone) => ({
            label:
              zoneCounts[zone] > 0 ? `${zone} (${zoneCounts[zone]})` : zone,
            value: zone,
            count: zoneCounts[zone],
          }))}
          title="Zone"
          selectedItems={selectedItemsOnZone}
          setSelectedItems={setSelectedItemsOnZone}
        />
      </div>
      <div className="SelectDate">
        <CalendarFilterComponent
          title="Start Date"
          selectedDate={selectStartDate}
          setSelectedDate={(date) => {
            setSelectStartDate(date);
            clearEndDate();
          }}
          clearEndDate={clearEndDate}
          width="120px"
        />
      </div>
      <div className="SelectDate">
        <CalendarFilterComponent
          title="End Date"
          providedDate={selectStartDate}
          selectedDate={selectEndDate}
          setSelectedDate={setSelectEndDate}
          inventories={specialInv}
          setFilteredInventories={setFilteredInventories}
          isEndDate={true}
          setSpecialInv={setSpecialInv}
          width="120px"
        />
      </div>
      <div className="refreshBtn">
        <div style={{ display: isMobile ? "none" : "block" }}>
          <Button
            style={{ display: "flex", alignItems: "center", gap: ".5rem" }}
            onClick={(e) => handleReset(e)}
          >
            <IoIosRefresh />
          </Button>
        </div>
        <Tooltip title="Campaign Duration" placement="bottom">
          <div>
            <InputNumber
              min={15}
              value={duration}
              onChange={(value) => setDuration(value)}
              placeholder="Campaign Duration"
              style={{ width: "70px" }}
            />
          </div>
        </Tooltip>
      </div>
      <div className="AddBulkBtn">
        <Tooltip
          title="Adds Filtered inventories in BULK"
          color="#FFCB10"
          placement="bottom"
        >
          <Button
            type="primary"
            style={{
              backgroundColor: "#ffa500",
              borderColor: "#ff8c00",
              color: "#fff",
              fontWeight: "500",
              fontSize: "12px",
            }}
            onClick={() => dispatch(addToCartInBulk(filteredInventories))}
          >
            Add In Bulk
          </Button>
        </Tooltip>
      </div>
      <div className="MobileFreidlyBtn">
        <button onClick={(e) => handleReset(e)}>Reset All</button>
        <button onClick={onClose}>Apply</button>
      </div>
    </div>
  );
  if (access == false) {
    return <AuthorizationError />;
  }
  return (
    <>
      <div id="FiltersInventory">
        <div style={{ position: "relative", width: "100%" }}>
          <div className="FilterBtn">
            {isMobile && (
              <Button onClick={showDrawer}>
                <IoFilterSharp />
              </Button>
            )}
          </div>
          {/* <Drawer title="Basic Drawer" onClose={onClose} open={open}>
            <p>Some contents...</p>
            <p>Some contents...</p>
            <p>Some contents...</p>
          </Drawer>
          <div id="FilterContainer">
            {(isDropdownOpen || !isMobile) && (
              <div style={{ display: "flex", flexDirection: isMobile ? "column" : "column", marginTop: isMobile ? "1rem" : "0" }}>
                <div style={{ display: "flex", flexDirection: isMobile ? "column" : "row", gap: ".4rem" }}>
                  <div>
                    <NamedSelectComponent
                      options={filteredMediaTypes.map(type => ({
                        label: typeCounts[type] > 0 ? `${type} (${typeCounts[type]})` : type,
                        value: type,
                        count: typeCounts[type]
                      }))}
                      title="Type"
                      selectedItems={selectedItemsOnType}
                      setSelectedItems={setSelectedItemsOnType}
                    />
                  </div>
                  <div>
                    <NamedSelectComponent
                      options={filteredAreas.map(area => ({
                        label: areaCounts[area] > 0 ? `${area} (${areaCounts[area]})` : area,
                        value: area,
                        count: areaCounts[area]
                      }))}
                      title="Area"
                      selectedItems={selectedItemsOnArea}
                      setSelectedItems={setSelectedItemsOnArea}
                    />
                  </div>
                  <div className="SelectDate">
                    <CalendarFilterComponent
                      title="Start Date"
                      selectedDate={selectStartDate}
                      setSelectedDate={setSelectStartDate}
                    />
                  </div>
                  <div className="SelectDate">
                    <CalendarFilterComponent
                      title="End Date"
                      providedDate={selectStartDate}
                      selectedDate={selectEndDate}
                      setSelectedDate={setSelectEndDate}
                      inventories={specialInv}
                      setFilteredInventories={setFilteredInventories}
                      isEndDate={true}
                      setSpecialInv={setSpecialInv}
                    />
                  </div>
                  <div className="refreshBtn">
                    <div>
                      <Button style={{ display: "flex", alignItems: "center", gap: ".5rem" }} onClick={(e) => handleReset(e)}>
                        <IoIosRefresh />
                      </Button>
                    </div>
                    <Tooltip title="Campaign Duration" placement="bottom">
                      <div>
                        <InputNumber
                          min={15}
                          value={duration}
                          onChange={(value) => setDuration(value)}
                          placeholder="Campaign Duration"
                        />
                      </div>
                    </Tooltip>
                  </div>
                  <div className="AddBulkBtn">
                    <Tooltip title="Adds Filtered inventories in BULK" color="#FFCB10" placement="bottom">
                      <Button
                        type="primary"
                        style={{
                          backgroundColor: "#ffa500",
                          borderColor: "#ff8c00",
                          color: "#fff",
                          fontWeight: "500",
                          fontSize: "12px"
                        }}
                        onClick={() => dispatch(addToCartInBulk(filteredInventories))}
                      >
                        Add In Bulk
                      </Button>
                    </Tooltip>
                  </div>
                </div>

              </div>
            )}
          </div> */}
          {isMobile ? (
            <div className="DrawerInsideStyle">
              <Drawer title="Inventories Filter" onClose={onClose} open={open}>
                {filterContent}
              </Drawer>
            </div>
          ) : (
            <div id="FilterContainer">{filterContent}</div>
          )}
        </div>
        <div style={{ alignSelf: "flex-start" }} id="RightSideMapView">
          <div>
            <span style={{ padding: "10px" }}>
              <h6
                style={{
                  color: "gray",
                  display: "inline",
                  marginRight: "1rem",
                  fontSize: ".8rem",
                }}
              >
                {filteredInventories.length}/{inventories.length}
              </h6>
              <b>Map&nbsp;View</b>
            </span>
            <Switch checked={toggleState} onChange={handleToggle} />
          </div>
        </div>
      </div>

      <div className="parent-padding-container" style={{ marginTop: "0px" }}>
        {/* Filtering components */}

        <div
          className="dashboard-main-container"
          style={{ display: "flex", flexWrap: "wrap" }}
        >
          {/* Card components */}
          <div className="dashboard-cards-reside" ref={dashboardCards}>
            {filteredInventories &&
              filteredInventories.length > 0 &&
              !toggleState ? (
              filteredInventories.map((item) => {
                return (
                  <CardContainer
                    data={item}
                    showModal={() => showModal(item)}
                  />
                );
              })
            ) : toggleState ? (
              <>
                <MapView filteredInventories={filteredInventories} />{" "}
              </>
            ) : (
              <div
                style={{
                  display: "grid",
                  placeItems: "center",
                  height: "100%",
                  width: "100%",
                  color: "gray",
                  fontWeight: "600",
                  fontSize: "2rem",
                }}
              >
                {loading ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "1rem",
                    }}
                  >
                    {/* <FaInbox /> No inventories */}
                    <Spin tip="Loading" size="large"></Spin>
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "1rem",
                    }}
                  >
                    <FaInbox /> No inventories
                    {/* <Spin tip="Loading" size="large"></Spin> */}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {/* Card Information */}
        <Modal
          width={850}
          height="auto"
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
        >
          {selectedData && (
            <>
              <div id="ModalResponsive">
                {isLoaded && selectedData.lat && selectedData.lng ? (
                  <GoogleMap
                    center={{ lat: selectedData.lat, lng: selectedData.lng }}
                    zoom={12}
                    mapContainerStyle={{
                      width: isMobile ? "100%" : "50%",
                      height: isMobile ? "25vh" : "",
                    }}
                  >
                    {/* Render markers for each location */}

                    <Marker
                      position={{
                        lat: selectedData.lat,
                        lng: selectedData.lng,
                      }}
                      icon={{
                        url: "https://prepseed.s3.ap-south-1.amazonaws.com/board.png",
                        scaledSize: new window.google.maps.Size(40, 40),
                      }}
                    // onClick={() => handleMarkerClick(location)}
                    // onMouseOver={() => handleMarkerHover(location)}
                    />
                  </GoogleMap>
                ) : (
                  <div style={{ width: isMobile ? "100%" : "50%" }}>
                    <img
                      src="/images/location_animation.gif"
                      alt="location"
                      style={{ width: "100%" }}
                    />
                  </div>
                )}

                <div style={{ width: isMobile ? "100%" : "50%" }}>
                  <Calendar fullscreen={false} cellRender={dateCellRender} />
                </div>
              </div>
              <div>
                <div className="card-modal-body">
                  <div className="modal-img-container">
                    {/* <img
                      style={{ width: "100%", objectFit: "cover" }}
                      src={selectedData?.img || "./images/loaderImage.png"}
                      alt=""
                    /> */}
                    <Image
                      src={selectedData?.img || "./images/loaderImage.png"}
                      alt="location"
                      style={{ width: "100%" }}
                      preview={{
                        src: selectedData?.img,
                      }}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      gap: "1rem",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "600",
                        color: "gray",
                        display: "flex",
                        gap: "1rem",
                      }}
                    >
                      <span>Code No: {selectedData?.CodeNo}</span>
                      <span>CAS Code: {selectedData?.CASCode}</span>
                    </div>
                    <span style={{ color: "#1A91FF", fontSize: "1rem" }}>
                      <a
                        className="location"
                        onClick={(e) => {
                          handleLocationClick(
                            selectedData.lat,
                            selectedData.lng
                          );
                        }}
                      >
                        <CiLocationArrow1 />
                        {selectedData.locations.name}
                      </a>
                    </span>
                  </div>
                </div>
                <div className="modal-info">
                  <div
                    style={{ display: "flex", marginTop: "1rem" }}
                    className="modal-info-child"
                  >
                    <ul>
                      <li>
                        <div>Media Vehicle</div>
                        <div>{selectedData?.typeOfMedia?.name}</div>
                      </li>
                      <li>
                        <div>Illu</div>
                        <div>{selectedData?.Illu}</div>
                      </li>
                      <li>
                        <div>Units</div>
                        <div>{selectedData?.unit}</div>
                      </li>
                      <li>
                        <div>Rate per month</div>
                        <div>
                          {formatIndianNumber(selectedData?.ratePerMonth)}
                        </div>
                      </li>
                      {display && (
                        <li>
                          <div>Display</div>
                          <div>{display}</div>
                        </li>
                      )}
                      <li>
                        <div>Availability</div>
                        <div>
                          {
                            dateAvailability(
                              selectedData?.Bookings,
                              false,
                              selectedData
                            )?.status
                          }
                        </div>
                      </li>
                      {(() => {
                        const today = moment().format("YYYY-MM-DD");
                        const activeBlock = getMergedBlockedDateDocuments(
                          selectedData,
                        ).find((block) => {
                          const start = moment(block.blockedAt).format(
                            "YYYY-MM-DD"
                          );
                          const end = moment(block.blockedTill).format(
                            "YYYY-MM-DD"
                          );
                          return today >= start && today <= end;
                        });
                        if (!activeBlock) return null;
                        return (
                          <li>
                            <div>Blocked</div>
                            <div>{blockedRangeDisplayLabel(activeBlock)}</div>
                          </li>
                        );
                      })()}
                      {nextBooking && (
                        <li>
                          <div>Next Booking</div>
                          <div>{nextBooking}</div>
                        </li>
                      )}
                    </ul>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "1rem",
                    }}
                    className="modal-info-child"
                  >
                    <RectangleGenerator
                      width={selectedData?.width}
                      height={selectedData?.height}
                      typeOfMediaName={selectedData?.typeOfMedia?.name}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
        </Modal>
      </div>
    </>
  );
}

export default DashboardContainer;
